/* unplugin-vue-components disabled */import script from "./SearchBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchBlock.vue?vue&type=script&lang=ts&setup=true"

import "./SearchBlock.vue?vue&type=style&index=0&id=5736f135&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5736f135"]])

export default __exports__